import React, { useMemo } from 'react';
import { Tabs } from '../../../../Components/Tabs/Tabs';
import { Select } from '../../../../Components/Select/Select';
import { Table } from '../../../../Components/Table/Table';
import { Pagination } from '../../../../Components/Pagination/Pagination';
import { CasesModal } from '../../../../Components/CasesModal/CasesModal';
import { ModalLoader } from '../../../../Components/ModalLoader';
import { RESULTS_TABS, getResultsColumns } from '../../constants';
import { ResultsTab } from '../../types';
import { StatsCards } from '../../../../Components/StatsCards/StatsCards';
import { ProgressOverview } from '../../../../Components/ProgressOverview/ProgressOverview';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import { useAdminResultsContent } from '../../hooks/useAdminResultsContent';
import './AdminResultsContent.scss';

export const ResultsContent: React.FC = () => {
  const { width } = useWindowDimensions();
  const {
    activeTab,
    selectedChallenge,
    challengeOptions,
    summary,
    currentData,
    totalPages,
    currentPageNumber,
    activeEvent,
    isLoading,
    isCasesModalOpen,
    selectedUserName,
    handleTabChange,
    handleChallengeChange,
    handlePageChange,
    closeCasesModal,
  } = useAdminResultsContent();

  const renderParticipantCell = (row: any) => (
    <div className="participant-cell">
      <div className="avatar">
        {row.participant
          .split(' ')
          .map((word: string) => word.charAt(0).toUpperCase())
          .join('')}
      </div>
      <span className="name">{row.participant}</span>
    </div>
  );

  const columns = useMemo(
    () =>
      getResultsColumns(activeTab).map((column) => {
        if (column.id === 'participant') return { ...column, render: renderParticipantCell };
        return column;
      }),
    [activeTab]
  );

  return (
    <div className="results-content">
      <div className="results-header-controls">
        <Tabs<ResultsTab> tabs={RESULTS_TABS} activeTab={activeTab} onTabChange={handleTabChange} />
        <div className="challenge-select">
          <Select
            id="challenge-select"
            name="challenge"
            options={challengeOptions}
            value={selectedChallenge}
            onChange={handleChallengeChange}
            placeholder="Select Challenge"
          />
        </div>
      </div>
      <div className="tabel-name">{activeEvent?.name || 'Challenge'}</div>
      <div className="results-table">
        {isLoading ? (
          <ModalLoader />
        ) : currentData.length === 0 ? (
          <div className="no-data-message">No data found</div>
        ) : (
          <>
            <Table columns={columns} data={currentData} />
            {totalPages > 1 && (
              <Pagination
                totalPages={totalPages}
                currentPage={currentPageNumber}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </div>
      {width <= 768 && summary && activeEvent && (
        <div className="mobile-stats-section">
          <ProgressOverview
            data={[
              {
                label: 'Total Hours',
                value: summary.totalHours,
                max: activeEvent.milestone,
              },
              {
                label: 'Total Reviews',
                value: summary.reviewsCount,
                max: summary.reviewMilestone,
              },
            ]}
          />
          <StatsCards summary={summary} />
        </div>
      )}

      {isCasesModalOpen && selectedUserName && (
        <CasesModal
          isOpen={isCasesModalOpen}
          onClose={closeCasesModal}
          userName={selectedUserName}
        />
      )}
    </div>
  );
};
